import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { useLocalization } from '~/composables/_next/useLocalization';
import { useCart } from '~/composables/useCart';
import { useShippingMethods } from '~/composables/useShippingMethods';
import { getCountryLabelByCode } from '~/utils/localization';
export default {
  __name: 'ProductDeliveryMessage',
  setup: function setup(__props) {
    var _useLocalization = useLocalization(),
      country = _useLocalization.country,
      currency = _useLocalization.currency;
    var _useCart = useCart(),
      cart = _useCart.cart;
    var _useShippingMethods = useShippingMethods(),
      shippingMethods = _useShippingMethods.shippingMethods,
      loadShippingMethods = _useShippingMethods.loadShippingMethods,
      getShippingFreeAboveRate = _useShippingMethods.getShippingFreeAboveRate;
    var remainingAmountFreeAboveRate = ref(null);
    watch(cart, /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(newValue, oldValue) {
        var _yield$getShippingFre, shippingFreeAboveRate;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!newValue || oldValue && oldValue.id === newValue.id)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              if (shippingMethods.value) {
                _context.next = 5;
                break;
              }
              _context.next = 5;
              return loadShippingMethods(newValue.id);
            case 5:
              _context.next = 7;
              return getShippingFreeAboveRate();
            case 7:
              _yield$getShippingFre = _context.sent;
              shippingFreeAboveRate = _yield$getShippingFre.shippingFreeAboveRate;
              remainingAmountFreeAboveRate.value = (shippingFreeAboveRate === null || shippingFreeAboveRate === void 0 ? void 0 : shippingFreeAboveRate.centAmount) / 100;
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(), {
      immediate: true
    });
    return {
      __sfc: true,
      country: country,
      currency: currency,
      cart: cart,
      shippingMethods: shippingMethods,
      loadShippingMethods: loadShippingMethods,
      getShippingFreeAboveRate: getShippingFreeAboveRate,
      remainingAmountFreeAboveRate: remainingAmountFreeAboveRate,
      AzIcon: AzIcon,
      getCountryLabelByCode: getCountryLabelByCode
    };
  }
};